import type { ReactNode } from "react";

import { useIsCommentsSectionVisible } from "./useIsCommentsSectionVisible";

export interface SectionProps {
  children: ReactNode;
}

export const Section = ({ children }: SectionProps) => {
  const isVisible = useIsCommentsSectionVisible();
  if (!isVisible) return null;
  return <>{children}</>;
};
